/*
    Create by fanglijuan 2019-04-29
*/
"use strict";
angular.module("appNewQuickSignTypeModule", [])
    .controller("appNewQuickSignTypeCtrl", ['$scope', '$q', '$state', '$modalInstance', 'trsHttpService', "trsspliceString", "modalDialog", "obj", "editingCenterService",
        function($scope, $q, $state, $modalInstance, trsHttpService, trsspliceString, modalDialog, obj, editingCenterService) {
            initStatus();
            initData();

            /**
             * [initStatus description]
             * @return {[type]} [description]
             */
            function initStatus() {
                $scope.status = {
                    selectedPlatformVal: 7, //固定写死,待编的7
                    modalTitle: obj.modalTitle,
                    selectedOriginType: "wx",
                    keywords: "",
                    copyKeywords: '',
                    classObj: {
                        wx: false,
                        app: false,
                        wz: false,
                        yp: false,
                        sp: false,
                        hd: false
                    },
                    totalNum: 0
                };
                $scope.data = {
                    originList: [],
                    selectedOrigin: {
                        wx: [],
                        app: [],
                        wz: [],
                    }, // 已选择的来源
                    ischeckedOriginIds: {}, // 已选择的来源id集合
                    copySelectedChnlId: ""
                };
                $scope.page = {
                    CURRPAGE: 1,
                    PAGESIZE: 10,
                    PAGECOUNT: 1,
                    ITEMCOUNT: 0
                };

            }

            /**
             * [initData description] 初始化数据
             * @return {[type]} [description]
             */
            function initData() {
                getOrigin(); // 获取来源信息
            }
            /**
             * [getOrigin description] 获取来源
             * @return {[type]} [description]
             */
            function getOrigin() {
                var deffer = $q.defer();
                // $scope.data.originList = [];
                var params = {
                    typeid: "zyzx",
                    serviceid: "iwo",
                    modelid: "subscription",
                    keyword: $scope.status.keywords,
                    channelName: $scope.status.selectedOriginType,
                    pageNum: $scope.page.CURRPAGE,
                    pageSize: $scope.page.PAGESIZE
                };
                trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, "post").then(function(data) {
                    if (data.result == 'success') {
                        $scope.data.originList = [].concat(data.content);
                        $scope.page.CURRPAGE = data.summary_info.CURRPAGE;
                        $scope.page.ITEMCOUNT = data.summary_info.ITEMCOUNT;
                        $scope.page.PAGECOUNT = data.summary_info.PAGECOUNT;
                    }
                    deffer.resolve(data);
                });
                return deffer.promise;
            }

            /**
             * [chooseOrigin description] 选择来源分类
             * @param  {[type]} type [description] 来源分类
             * @return {[type]}      [description]
             */
            $scope.chooseOrigin = function(channel) {
                if ($scope.status.selectedOriginType == channel) return;
                $scope.status.selectedOriginType = channel;
                $scope.status.keywords = "";
                $scope.page.CURRPAGE = 1;
                getOrigin();
            };

            /**
             * [searchOrigin description] 搜索
             * @return {[type]} [description]
             */
            $scope.searchOrigin = function() {
                getOrigin();
            };
            /**
             * [pageChanged description] 分页
             * @return {[type]} [description]
             */
            $scope.pageChanged = function() {
                getOrigin();
            };
            /**
             * [chooseOriginName description] 选择来源
             * @param  {[type]} item [description]
             * @return {[type]}      [description]
             */
            $scope.chooseOriginName = function(item) {
                var falg = false,
                    index = 0;
                $scope.status.classObj[$scope.status.selectedOriginType] = $scope.status.selectedOriginType; //展开右侧
                var arr = $scope.data.selectedOrigin[$scope.status.selectedOriginType];
                for (var i = 0; i < arr.length; i++) {
                    if (arr[i].HYBASEID == item.HYBASEID) {
                        falg = true;
                        index = i;
                        break;
                    }
                }
                if (!falg) {
                    $scope.data.selectedOrigin[$scope.status.selectedOriginType].push(item);
                    $scope.status.totalNum++;
                } else {
                    $scope.data.selectedOrigin[$scope.status.selectedOriginType].splice(index, 1);
                    $scope.status.totalNum--;
                }
            };
            /**
             * [ischecked description] 是否选中
             * @param  {[type]} item [description]
             * @return {[type]}      [description]
             */
            $scope.ischecked = function(item) {
                var falg = false,
                    index = 0;
                var arr = $scope.data.selectedOrigin[$scope.status.selectedOriginType];
                for (var i = 0; i < arr.length; i++) {
                    if (arr[i].HYBASEID == item.HYBASEID) {
                        falg = true;
                        index = i;
                        break;
                    }
                }
                if (!falg) {
                    return false;
                } else {
                    return true;
                }
            };

            /**
             * [removeSelectedItem description] 删除已选择
             * @param  {[type]} item [description]
             * @return {[type]}      [description]
             */
            $scope.removeSelectedItem = function(key, item) {
                angular.forEach($scope.data.selectedOrigin, function(value, key) {
                    if (value.indexOf(item) >= 0) {
                        value.splice(value.indexOf(item), 1);
                        $scope.status.totalNum--;
                        return;
                    }
                });
            };
            /**
             * [confirm description] 提交
             * @return {[type]} [description]
             */
            $scope.confirm = function() {
                var submitArray = [];
                angular.forEach($scope.data.selectedOrigin, function(value, key) {
                    for (var i = 0; i < value.length; i++) {
                        submitArray.push({
                            categoryid: value[i].HYBASEID,
                            categoryname: key == 'wx' ? value[i].SOURCENAME : value[i].SOURCENAME + " | " + value[i].CHANNEL
                        });
                    }
                });
                var params = {
                    serviceid: "mlf_appquickpublish",
                    methodname: "saveQuickPubTypes",
                    SITEID: obj.siteid,
                    CATEGORYINFO: JSON.stringify(submitArray)
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "post").then(function(data) {
                    $modalInstance.close(data);
                }, function() {
                    $modalInstance.close('success');
                });
            };
            /**
             * [cancel description] 取消
             * @return {[type]} [description]
             */
            $scope.cancel = function() {
                $modalInstance.dismiss();
            };
        }
    ]);